export class ReceberQuitarDados {
  ReceberId = 0;
  DataRecebimento: string;
  NovoHistorico = '';

  constructor(id: number, data: string, historico: string) {
    this.ReceberId = id;
    this.DataRecebimento = data;
    this.NovoHistorico = historico;
  }
}
